//
//
//
//
//

export default {
    name: '',
    props: {
        total: {
            type: Number,
            default: 10
        },
        current: {
            type: Number,
            default: 1
        },
        rows: {
            type: Number,
            default: 10
        }
    },
    methods: {
        change(page) {
            // Nuxt直接引用Pager会报错，包一层
            // this.$emit("update:")
            this.$emit('change', page)
        }
    }
}
